import { useContext, useMemo } from 'react'
import { useFirestoreOrderBy } from '../../../firebase/useFirestore'
import { PersonaNavigation } from '../../../StateManagment/PersonaNavigation'
import EntityMeasurementSummary from '../../Research/EntityMeasurementSummary'
import { effectiveResearchDocs } from '../../../helpers/measurementSignals/effectiveResearchIds'

// AI-CONTEXT: See docs/features/meetmoment-signalering.md

const MAX_SHOWN = 3

/**
 * De onderzoeken waaraan deze deelnemer meedoet, met per onderzoek wat er is
 * ingevuld en wat er openstaat.
 *
 * @param {object} props
 * @param {{ID?: string, Research?: Array<string>}} props.item - De deelnemer
 */
const ResearchCard = ({ item }) => {
    const [, setPersonaNavigation] = useContext(PersonaNavigation)

    const allResearch = useFirestoreOrderBy('Research', 'Position', 'asc')

    // Zolang de onderzoeken nog niet binnen zijn is 'geen onderzoeken
    // gekoppeld' een onware bewering. Laden is een eigen toestand.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const loaded = Array.isArray(allResearch)

    // Handmatig gekoppeld plus elk onderzoek dat voor alle medewerkers geldt —
    // dezelfde regel als de signalering en de tabs.
    // AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md
    const linked = useMemo(
        () => effectiveResearchDocs({ kind: 'persona', linkedIds: item?.Research, researches: allResearch })
            .slice(0, MAX_SHOWN),
        [allResearch, item]
    )

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Onderzoeken</h3>
                {!loaded ? (
                    <p className="adress-dashboard-empty">Laden…</p>
                ) : linked.length === 0 ? (
                    <p className="adress-dashboard-empty">Nog geen onderzoeken gekoppeld.</p>
                ) : (
                    <EntityMeasurementSummary
                        entityId={item?.ID}
                        researches={linked}
                        startLabel="Meedoen sinds"
                    />
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setPersonaNavigation('research')}
                >
                    Bekijk alle onderzoeken →
                </button>
            </div>
        </div>
    )
}

export default ResearchCard
